import { render, staticRenderFns } from "./VacationForm.vue?vue&type=template&id=98b8e224"
import script from "./VacationForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./VacationForm.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports